import React, { useEffect, useState } from "react";
import "./SpendingPrediction.css";
const REACT_APP_EXPRESS_API = process.env.REACT_APP_EXPRESS_API;

/**
 * Pakai ENV:
 * - REACT_APP_API_URL = http://localhost:5001
 * - fallback ke localhost bila ENV tidak di-set
 * - otomatis menambahkan /api/transactions/predictive tanpa double slash
 */
const BASE_URL =
  (typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_API_URL) ||
  `${REACT_APP_EXPRESS_API}`;
const API_URL = `${String(BASE_URL).replace(/\/$/, "")}/api/transactions/predictive`;

export default function SpendingPrediction() {
  const [summary, setSummary] = useState({
    predict_tomorrow: 0,
    predict_next_week: 0,
    predict_month: 0,
  });

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(API_URL, {
          method: "GET",
          credentials: "include", // penting: kirim cookie/session ke backend
          headers: { Accept: "application/json" },
        });
        const raw = await res.json();
        const s = raw?.summary || {};
        setSummary({
          predict_tomorrow: Number(s.predict_tomorrow || 0),
          predict_next_week: Number(s.predict_next_week || 0),
          predict_month: Number(s.predict_month || 0),
        });
      } catch (e) {
        console.error("Gagal memuat ringkasan prediksi:", e);
      }
    })();
  }, []);

  const fmt = (n) =>
    `Rp${Number(n || 0).toLocaleString("id-ID", { maximumFractionDigits: 0 })}`;

  return (
    <div className="prediction-section">
      <div className="prediction-panel">
        <h3 className="prediction-title">Ringkasan Prediksi Pengeluaran</h3>

        <div className="prediction-cards">
          <div className="prediction-card filled">
            <div className="prediction-chip">Besok</div>
            <div className="prediction-amount">{fmt(summary.predict_tomorrow)}</div>
          </div>

          <div className="prediction-card outline">
            <div className="prediction-chip">Minggu Depan</div>
            <div className="prediction-amount">{fmt(summary.predict_next_week)}</div>
          </div>

          <div className="prediction-card outline">
            <div className="prediction-chip">Bulan Depan</div>
            <div className="prediction-amount">{fmt(summary.predict_month)}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
